import { render, staticRenderFns } from "./PaymentsSettings.vue?vue&type=template&id=271cab62"
import script from "./PaymentsSettings.vue?vue&type=script&lang=js"
export * from "./PaymentsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports